import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const LoginHeader = () => {
  return (
    <div className="text-center mb-8">
      <Link to="/game-library-dashboard" className="inline-flex items-center space-x-2 mb-6">
        <div className="w-12 h-12 bg-gradient-to-br from-primary to-secondary rounded-xl flex items-center justify-center">
          <Icon name="Gamepad2" size={24} color="white" />
        </div>
        <span className="text-2xl font-bold text-foreground">Solis Games</span>
      </Link>
      
      <h1 className="text-3xl font-bold text-foreground mb-2">Welcome Back</h1>
      <p className="text-muted-foreground mb-6">
        Sign in to continue your gaming adventure
      </p>
      
      <div className="flex items-center justify-center space-x-2 text-sm text-muted-foreground">
        <span>Don't have an account?</span>
        <Link to="/user-registration">
          <Button variant="link" className="p-0 h-auto text-primary hover:text-primary/80">
            Sign up for free
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default LoginHeader;
